<template>
  <BGModal :shown="dialogShown"
           :title="$t('admin_series.add_title')">
    <template #content>
      <v-container fluid class="add-series" v-if="event">
        <v-form v-model="isFormValid"
                ref="addSeriesForm">
          <v-row class="flex-grow-1">
            <v-col cols="8" class="d-flex session-selection">
              <v-input :rules="selectedSessionIdRules"
                       v-model="selectedSessionIds"
                       hide-details="auto">
                <v-container fluid class="flex-grow-1 d-flex flex-column pa-0">
                  <v-row class="flex-grow-0">
                    <v-col>
                      <legend class="v-label theme--light">{{ $t('admin_series.sessions') }}</legend>
                    </v-col>
                  </v-row>
                  <v-row class="flex-grow-1" no-gutters>
                    <v-col>
                      <SessionList full-height
                                   hide-search
                                   :event-id="eventId"
                                   show-select
                                   v-model="selectedSessionIds"></SessionList>
                    </v-col>
                  </v-row>
                </v-container>
              </v-input>
            </v-col>
            <v-col cols="4">
              <v-text-field readonly
                            :label="$t('admin_hkiarace.event')"
                            :value="$sanitizeHtml(event.name)"></v-text-field>
              <v-text-field readonly
                            :label="$t('admin_event.signup_mode')"
                            :value="signupModeLabel"></v-text-field>
              <v-text-field outlined
                            :label="$t('admin_session.name_en')"
                            v-model="series.name_en"
                            :rules="requiredRules"></v-text-field>
              <v-text-field outlined
                            :label="$t('admin_session.name_zh')"
                            v-model="series.name_zh"
                            :rules="requiredRules"></v-text-field>
              <v-text-field outlined
                            :label="$t('admin_event.order_no')"
                            v-model="series.order_no"
                            type="number"
                            min="0"
                            step="1"
                            :rules="requiredRules"></v-text-field>
              <v-input :rules="[
                      value => (unlimitedQuota || !!value) || $t('register.required_fields'),
                    ]"
                       v-model="series.quota"
                       v-if="event.signup_mode === 2">
                <v-container fluid class="px-0">
                  <v-row>
                    <v-col class="pb-0">
                      <v-text-field outlined
                                    :label="$t('admin_series.quota')"
                                    type="number"
                                    v-model="series.quota"
                                    hide-details
                                    :disabled="unlimitedQuota">
                      </v-text-field>
                    </v-col>
                    <v-col cols="2" class="pb-0">
                      <v-checkbox :label="$t('unlimited')"
                                  v-model="unlimitedQuota"></v-checkbox>
                    </v-col>
                  </v-row>
                </v-container>
              </v-input>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </template>

    <template #footer>
      <v-row no-gutters>
        <v-btn @click="cancel"
               class="mr-3"
               depressed
               large>
          {{ $t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               depressed
               large
               @click="$refs.addSeriesForm.validate() && save()">
          {{ $t('save') }}
          <v-icon right>fas fa-check</v-icon>
        </v-btn>
      </v-row>
    </template>
  </BGModal>
</template>

<script>
import {computed, ref, watch} from "@vue/composition-api";
import BGModal from "@/components/BGModal";
import SessionList from "@/components/event/session/SessionList";

export default {
  name: 'AddSeriesModal',
  components: {SessionList, BGModal},
  props: {
    eventId: String,
    shown: Boolean,
  },
  setup(props, {root, emit}) {
    const dialogShown = ref(props.shown);

    // Init
    watch(() => props.shown, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        dialogShown.value = newValue;

        if (newValue) {
          getEvent();
          selectedSessionIds.value = [];
          series.value = {};
        }
      }
    });
    const cancel = function () {
      emit('cancel');
    };

    // Form
    const isFormValid = ref(false);
    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);

    const event = ref(null);
    const getEvent = function () {
      root.$callAPI('hkiarace/admin/event/', {id: props.eventId}, function (response) {
        event.value = response.body.event;
      })
    };
    const signupModeLabel = computed(() => {
      if (event.value) {
        return {
          "-1": root.$t('event_signup_mode.disabled'),
          "1": root.$t('event_signup_mode.single_series'),
          "2": root.$t('event_signup_mode.multi_session'),
          "3": root.$t('event_signup_mode.multi_series'),
        }[event.value.signup_mode];
      }
    })

    const series = ref({});
    const unlimitedQuota = ref(false);

    const selectedSessionIdRules = ref([
      value => value.length > 0 || root.$t('admin_series.no_session_msg'),
    ]);
    const selectedSessionIds = ref([]);

    const save = function () {
      let params = {
        ...series.value,
        event_id: props.eventId,
        quota: (event.value.signup_mode === 2 && !unlimitedQuota.value) ? series.value.quota : -1,
        session_ids: selectedSessionIds.value,
      }

      root.$callAPI('event/series/create/', params, (response) => {
        emit('finish', response.body.series);
      });
    }

    return {
      dialogShown,
      cancel,

      isFormValid,
      requiredRules,

      event,
      signupModeLabel,

      series,
      unlimitedQuota,

      selectedSessionIdRules,
      selectedSessionIds,

      save,
    }
  },
}
</script>

<style lang="less">
.add-series {
  height: 100%;
  display: flex;
  flex-direction: column;

  .v-form {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;

    .session-selection {
      .v-input {
        //flex: 1 1 auto;
        display: flex;
        flex-direction: column;

        .v-input__control {
          display: flex;
          flex-direction: column;

          .v-input__slot {
            flex: 1 1 auto;
            flex-direction: column;
          }

          .v-messages {
            flex: 0 0 auto;
          }
        }
      }
    }
  }
}
</style>
